import { DataGrid } from "@mui/x-data-grid";
import {
  Box,
  Grid,
  Typography,
  Button,
  CircularProgress,
  TextField,
  Select,
  MenuItem,
  Card,
  CardContent,
  FormControl,
  InputLabel,
  Paper
} from "@mui/material";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { legalTeamApi } from "../../api/api";

const SaleGrid = () => {
  const userId = useSelector((state) => state.user.userId);
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await legalTeamApi.getLegalTeamSaleUpdates(userId);
        const formattedData = response.data.map((item) => ({
          id: item.id,
          propertyId:item.Pid,
          projectId:item.ProjectId,
          apartmentId:item.ApartmentId,
          ApartmentName:item.ApartmentName,
          PropertyType:item.PropertyType,
          PropertyName: item.PropertyName,
          Address: item.Address,
          City: item.City,
          Status: item.Status,
          ProjectName:item.project_name
        }));

        setRows(formattedData);
        setFilteredRows(formattedData);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [userId]);

  useEffect(() => {
    const filter = rows.filter((row) => {
      const matchesSearch = row.PropertyName.toLowerCase().includes(search.toLowerCase());
      const matchesStatus = statusFilter ? row.Status === statusFilter : true;
      return matchesSearch && matchesStatus;
    });

    setFilteredRows(filter);
  }, [search, statusFilter, rows]);

  const handleUpdate = (row) => {
    navigate("/legalteam/updatesale", { state: { saledata: row } });
  };
  const renderCellWithFallback = (params) => {
  return params.value === null || params.value === undefined || params.value === ''
    ? '------'
    : params.value;
};


  const columns = [
    { field: "id", headerName: "Id", width: 100 ,renderCell:renderCellWithFallback},
    {
      field:"ApartmentName",headerName:"Apartment Name",width:200,renderCell:renderCellWithFallback
    },
    {field:"ProjectName",headerName:"Project Name",width:200,renderCell:renderCellWithFallback},
    { field: "PropertyName", headerName: "Property Name", width: 200,renderCell:renderCellWithFallback },
    {field:"PropertyType",headerName:"Property Type",width:200 ,renderCell:(params)=>{
      const typeMap={
        1:"Project",
        2:"Property",
        3:"Apartment",
        4:"Individual Villa"
      };
      return typeMap[params.value] || "Unknown"
    }},
    { field: "Address", headerName: "Address", width: 200 ,renderCell:renderCellWithFallback},
    { field: "City", headerName: "City", width: 150,renderCell:renderCellWithFallback },
    { field: "Status", headerName: "Status", width: 150,renderCell:renderCellWithFallback },
    {
      field: "approve",
      headerName: "Action",
      width: 150,
      renderCell: (params) => (
        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={() => handleUpdate(params.row)}
        >
          Update
        </Button>
      )
    }
  ];

  return (
    <Paper elevation={3} sx={{ p: 3, m: 3 }}>
      <Typography variant="h5" gutterBottom>
        Sale Properties Assigned
      </Typography>

      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                label="Search by Property Name"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <FormControl fullWidth>
                <InputLabel>Status Filter</InputLabel>
                <Select
                  value={statusFilter}
                  onChange={(e) => setStatusFilter(e.target.value)}
                  label="Status Filter"
                >
                  <MenuItem value="">All</MenuItem>
                  <MenuItem value="InProgress">InProgress</MenuItem>
                  <MenuItem value="Approved">Approved</MenuItem>
                  <MenuItem value="Completed">Sold</MenuItem>
                  <MenuItem value="Rejected">Rejected</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
          <CircularProgress />
        </Box>
      ) : (
        <Box
  sx={{
    height: 500,
    width: "100%",
    "& .MuiDataGrid-root": {
      borderRadius: 2,
      border: "1px solid #ccc",
      fontFamily: "'Roboto', sans-serif",
      fontSize: "14px",
      color: "#333",
      backgroundColor: "#fafafa",
    },
    "& .MuiDataGrid-columnHeaders": {
      backgroundColor: "#1976d2",
      color: "#fff",
      fontWeight: "bold",
      fontSize: "16px",
    },
    "& .MuiDataGrid-cell": {
      borderBottom: "1px solid #e0e0e0",
      padding: "8px",
    },
    "& .MuiDataGrid-row:hover": {
      backgroundColor: "#e3f2fd",
      cursor: "pointer",
    },
    "& .MuiDataGrid-footerContainer": {
      borderTop: "1px solid #ccc",
      backgroundColor: "#f5f5f5",
    },
    "& .MuiDataGrid-selectedRowCount": {
      fontWeight: "bold",
      color: "#1976d2",
    },
    "& .MuiDataGrid-iconSeparator": {
      display: "none",
    }
  }}
>
  <DataGrid
    rows={filteredRows}
    columns={columns}
    pageSize={7}
    rowsPerPageOptions={[7]}
    disableSelectionOnClick
    autoHeight={false}
    sx={{
      // override DataGrid internal styles if needed here too
    }}
  />
</Box>

      )}
    </Paper>
  );
};

export default SaleGrid;
